module.exports = __webpack_public_path__ + "static/media/zoomout.e32f3503.svg";